const THIRTY_MINS = 30 * 60 * 1000;
const TWELVE_HOURS = 12 * 60 * 60 * 1000;

export const TIME_INTERVAL_CONFIG = {
  CHECKIN_START: TWELVE_HOURS,
  CHECKIN_END: TWELVE_HOURS,
  MEET_JOIN_START: THIRTY_MINS,
  MEET_JOIN_END: TWELVE_HOURS,
  BOOKINGS_END: TWELVE_HOURS,
  TICKET_CLOSE: THIRTY_MINS,
};